import { render, staticRenderFns } from "./IcoArrowOutRightRectangle.vue?vue&type=template&id=67cfad94"
import script from "./IcoArrowOutRightRectangle.vue?vue&type=script&lang=js"
export * from "./IcoArrowOutRightRectangle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports